export const COOKIE_KEYS = {
  LOCALE: '__tidb-locale',
};

export const ROLE_KEYS = {
  ADMIN: 'admin',
  MEMBER: 'member',
};

export const ROLE_NAMES = {
  [ROLE_KEYS.ADMIN]: '管理员',
  [ROLE_KEYS.MEMBER]: '成员',
};
